/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { REST_CONSTANTS } from "../utils/data.rest.constants";
import { MerchantUserRoles } from "../models/merchant-user-roles";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class MerchantUserService {
  private _usersAndRoles!: MerchantUserRoles[];

  constructor(private http: HttpClient) {}

  getUsersAndRoles(merchantId: number): Observable<MerchantUserRoles[]> {
    const url = `${REST_CONSTANTS.MERCHANT_BASE_URL_INTERNAL}/merchants/${merchantId}/users`;

    return this.http
      .get<MerchantUserRoles[]>(url, { headers: REST_CONSTANTS.JSON_HEADER })
      .pipe(catchError(MerchantUserService.handleError));
  }

  handleRoles(merchantId: number, merchantUserRole: MerchantUserRoles): Observable<MerchantUserRoles> {
    const url = `${REST_CONSTANTS.MERCHANT_BASE_URL_INTERNAL}/merchants/${merchantId}/users`;

    return this.http
      .post<MerchantUserRoles>(url, merchantUserRole, { headers: REST_CONSTANTS.JSON_HEADER })
      .pipe(catchError(MerchantUserService.handleError));
  }

  private static handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

  set usersAndRoles(usersAndRoles: MerchantUserRoles[]) {
    this._usersAndRoles = usersAndRoles;
  }

  get usersAndRoles() {
    return this._usersAndRoles;
  }
}
